import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/climatespy.svg")